import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useCreateTicketPriority } from '../../../hooks/TICKET/useCreateTicketPriority';

const NewPriority = ({ showNewPriority, setShowNewPriority }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', label: '' });

    const { mutateAsync: createPriority } = useCreateTicketPriority();

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.nom) { alert("Le nom est obligatoire"); return; }
        setIsSubmitting(true);
        try {
            await createPriority({ nom: formData.nom, label: formData.label || undefined });
            setFormData({ nom: '', label: '' });
            setShowNewPriority(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showNewPriority} onHide={() => setShowNewPriority(false)} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Ajouter une priorité</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idNom">
                        <Form.Label className='text-muted'>Nom (obligatoire)</Form.Label>
                        <Form.Control type="text" placeholder="Nom de la priorité" value={formData.nom} onChange={(e) => setFormData({ ...formData, nom: e.target.value })} required maxLength={255} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idLabel">
                        <Form.Label className='text-muted'>Label (optionnel)</Form.Label>
                        <Form.Control type="text" placeholder="Label de la priorité" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} maxLength={255} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowNewPriority(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Chargement...' : 'Créer'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default NewPriority;